var _a, _b, _c, _d, _e, _f, _g;
import pino from "pino";
export const logger = pino({
    base: {
        logtype: "pino",
        sstApp: (_a = process.env.SST_APP) !== null && _a !== void 0 ? _a : "unknown",
        sstStage: (_b = process.env.SST_STAGE) !== null && _b !== void 0 ? _b : "unknown",
        sstStack: (_c = process.env.SST_STACK_NAME) !== null && _c !== void 0 ? _c : "unknown",
    },
    level: (_d = process.env.LOG_LEVEL) !== null && _d !== void 0 ? _d : "info",
    formatters: {
        level: (label) => {
            return {
                level: label,
            };
        },
    },
});
export const edgeLogger = pino({
    base: {
        logtype: "edge",
        sstApp: (_e = process.env.SST_APP) !== null && _e !== void 0 ? _e : "unknown",
        sstStage: (_f = process.env.SST_STAGE) !== null && _f !== void 0 ? _f : "unknown",
        sstStack: (_g = process.env.SST_STACK_NAME) !== null && _g !== void 0 ? _g : "unknown",
    },
    browser: {
        write: (o) => console.log(o),
    },
});
export function log(logger, level) {
    switch (level) {
        case "fatal":
            return logger.fatal.bind(logger);
        case "error":
            return logger.error.bind(logger);
        case "warn":
            return logger.warn.bind(logger);
        case "info":
            return logger.info.bind(logger);
        case "debug":
            return logger.debug.bind(logger);
        case "trace":
            return logger.trace.bind(logger);
    }
}
// export const withRequest = lambdaRequestTracker()
